import { animateScrollLeft, breakpoint } from 'ui-helpers';

function SetMobileClickEvents() {
  const mobileMenu = document.getElementById('gcc-mobile-menu');
  if (sessionStorage.fonts) {
    document.documentElement.classList.add('fonts-loaded', 'material-loaded');
  }

  document.addEventListener('DOMContentLoaded', () => {
    const menuToggle = document.getElementById('gcc-header-toggle-menu');
    if (menuToggle) {
      menuToggle.addEventListener('click', (event) => {
        event.preventDefault();
        const sidebarClass = 'with-sidebar';
        const { webFontsEvent } = window;
        window.dispatchEvent(webFontsEvent);
        if (document.body.classList) {
          document.body.classList.toggle(sidebarClass);
        } else {
          const classes = document.body.className.split(' ');
          const existingIndex = classes.indexOf(sidebarClass);
          if (existingIndex >= 0) {
            classes.splice(existingIndex, 1);
          } else {
            classes.push(sidebarClass);
          }
          document.body.className = classes.join(' ');
        }
        document.getElementById('gcc-mobile-menu').scrollLeft = 0;
      });
    }

    document.getElementById('gcc-site-menu-overlay').addEventListener('click', () => {
      const el = document.body;
      const sidebarClass = 'with-sidebar';
      if (el.classList) {
        el.classList.remove(sidebarClass);
      } else {
        const regex = new RegExp(`(^|\\b)${sidebarClass.split(' ').join('|')}(\\b|$)`, 'gi');
        el.className = el.className.replace(regex, ' ');
      }
    });
    document.getElementById('gcc-nav-back').addEventListener('click', () => {
      animateScrollLeft(document.getElementById('gcc-mobile-menu'), 0);
    });

    document
      .querySelectorAll('#gcc-mobile-menu .gcc-menu-inspiration li[data-type="prismic"]')
      .forEach((el) => document.querySelector('.gcc-menu-inspiration-from-customers').appendChild(el));

    const elementsArray = document.querySelectorAll('#gcc-mobile-menu > nav > ul > li > a');
    elementsArray.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const $this = e.target;
        if (breakpoint() !== 'large' || breakpoint() !== 'extra-large') {
          const $orderTracking = $this.closest('li');
          if ($orderTracking.getAttribute('id') === 'orderTracking') {
            return;
          }
          const $li = $this.closest('li').querySelectorAll('li');
          if ($li.length === 0) {
            return;
          }
          e.preventDefault();
          const width = mobileMenu.offsetWidth;
          const $img = $this.closest('li').querySelectorAll('img');
          let $submenu = '<ul class="list ma0 pa0 br3 b--navy br--bottom justify-between">';
          if ($img.length > 0) {
            $submenu += `
            <li class="bb b--white-10 pa2 w-100 tc">
              <img class="dib w-third" src="${$img[0].src}">
            </li>
          `;
          }
          $li.forEach((liItem) => {
            const href = liItem.querySelector('a').getAttribute('href');
            const pickShip =
              liItem.querySelector('a').innerText === 'Pick & Ship Blinds' ||
              liItem.querySelector('a').innerText === 'Pick & Ship Shades';
            const pickShipIcon =
              '<img style="position: relative; top: 2px; margin-right: 5px;" alt="pick-ship" src="/javascript/bcom/header-footer/svg/pick-ship.svg"/>';
            $submenu += `
            <li class="bb b--white-10 pl1 w-100">
              <a class="db fw3 white mv2 f5" href="${href}">
                ${pickShip ? pickShipIcon : ''}
                ${liItem.querySelector('a').innerText}
                <span class="material-icons v-mid f5 fr fn-l lh-copy mr2">chevron_right</span>
              </a>
            </li>
          `;
          });
          $submenu += '</ul>';
          document.querySelector('#gcc-header-subnavigation label').innerText = $this.getAttribute('title');
          document.querySelector('#gcc-header-subnavigation-content').innerHTML = $submenu;
          animateScrollLeft(document.getElementById('gcc-mobile-menu'), width);
        }
      });
    });
  });
}
export default SetMobileClickEvents;
